import React from 'react';
import { Ads, inlineDefineAd } from './Ad';

export interface AdSetupProps {
  /** Any ad definitions to setup to be requested as part of the initial ad request. */
  predefineAds?: Ads;
  pageLevelTargeting?: { key: string, value: string }[];
}

/** Sets up a view to display ads. */
const AdSetup = ({ 
  predefineAds = {},
  pageLevelTargeting = [] 
}: AdSetupProps) => {
  // console.log('AdSetup', predefineAds);
  if (process.env.TESTING === 'true') {
    return <></>;
  }
  return (
    <script
      data-cfasync={'false'}
      dangerouslySetInnerHTML={{
        __html: `
    window.googletag = window.googletag || {cmd: []};
    window.localStorage.setItem('sas_page-level-targeting', '${JSON.stringify(pageLevelTargeting)}');
    window.localStorage.setItem('sas_predefine-ads', '${JSON.stringify(predefineAds)}');
    
    googletag.cmd.push(function() {
      if (window.STARLORD_ADS_SETUP) return;
      var uuid = window.localStorage.getItem('sas_uuid');
      if (uuid) {
        googletag
          .pubads()
          .setPublisherProvidedId(uuid);
      }

      //  Page level googletag targeting
      ${pageLevelTargeting.reduce(
        (result, { key, value }) => {
          return `googletag.pubads().setTargeting('${key}', '${value}');\n${result}`;
        },
        ''
      )}
      
      ${Object.keys(predefineAds).reduce((result, key) => `${inlineDefineAd(predefineAds[key])}\n${result}`, '')}

      googletag.pubads();
      googletag.pubads().setCentering(true);
      googletag.pubads().collapseEmptyDivs();
      googletag.enableServices();
      window.STARLORD_ADS_SETUP = true;
    });
  `,
      }}
    />
  );
};

export default AdSetup;
